import PayDuesPage from "../components/payDues/main";

const PayDues = () => {
  return <PayDuesPage />;
};

export default PayDues;
